module.exports = __webpack_public_path__ + "static/treant-43301cca1caad67a07bb05374cc10a76.jpeg";